import React, { useState, useEffect } from 'react';
import { useHistory, Link, useParams } from 'react-router-dom';
import SuperadminLayout from './SuperadminLayout';
import axios from '../../axios/axiosconf';
import './SuperadminStyles.css';

const EditarTipoContrato = () => {
    const history = useHistory();
    const { id } = useParams();
const [formData, setFormData] = useState({
        nombre: ''
    });
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('superadmin_token');
        const user = localStorage.getItem('superadmin_user');

        if (!token || !user) {
            history.push('/superadmin/login');
            return;
        }
axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        fetchTipoContrato();
    }, [history, id]);

    const fetchTipoContrato = async () => {
        try {
            const response = await axios.get(`/superadmin/tipos-contrato/${id}`);
            setFormData({
                nombre: response.data.nombre
            });
            setLoading(false);
        } catch (error) {
            console.error('Error fetching tipo contrato:', error);
            if (error.response && error.response.status === 401) {
                localStorage.removeItem('superadmin_token');
                localStorage.removeItem('superadmin_user');
                history.push('/superadmin/login');
            } else {
                setErrors({
                    general: 'Error al cargar el tipo de contrato'
                });
                setLoading(false);
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        // Limpiar error del campo
        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: ''
            });
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.nombre.trim()) {
            newErrors.nombre = 'El nombre es requerido';
        } else if (formData.nombre.length > 255) {
            newErrors.nombre = 'El nombre no puede exceder 255 caracteres';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setSubmitting(true);

        try {
            await axios.put(`/superadmin/tipos-contrato/${id}`, formData);
            history.push('/superadmin/tipos-contrato');
        } catch (error) {
            console.error('Error updating tipo contrato:', error);
            if (error.response && error.response.data.errors) {
                setErrors(error.response.data.errors);
            } else {
                setErrors({
                    general: error.response?.data?.message || 'Error al actualizar el tipo de contrato'
                });
            }
            setSubmitting(false);
        }
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner-border text-info" role="status">
                    <span className="sr-only">Cargando...</span>
                </div>
            </div>
        );
    }

    return (
        <SuperadminLayout>
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h4><i className="fas fa-file-contract"></i> Editar Tipo de Contrato</h4>
                                <Link to="/superadmin/tipos-contrato" className="btn btn-secondary">
                                    <i className="fas fa-arrow-left"></i> Volver
                                </Link>
                            </div>

                            {errors.general && (
                                <div className="alert alert-danger">
                                    {errors.general}
                                </div>
                            )}

                            <form onSubmit={handleSubmit}>
                                <div className="form-section">
                                    <h5>Información del Tipo de Contrato</h5>
                                    
                                    <div className="form-group">
                                        <label htmlFor="nombre">Nombre <span className="text-danger">*</span></label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.nombre ? 'is-invalid' : ''}`}
                                            id="nombre"
                                            name="nombre"
                                            value={formData.nombre}
                                            onChange={handleChange}
                                            maxLength="255"
                                            placeholder="Ej: Tiempo Completo"
                                        />
                                        {errors.nombre && (
                                            <div className="invalid-feedback">
                                                {errors.nombre}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="form-group">
                                    <button
                                        type="submit"
                                        className="btn btn-superadmin"
                                        disabled={submitting}
                                    >
                                        {submitting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                Guardando...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-save"></i> Guardar Cambios
                                            </>
                                        )}
                                    </button>
                                    <Link to="/superadmin/tipos-contrato" className="btn btn-secondary ml-2">
                                        Cancelar
                                    </Link>
                                </div>
                            </form>
        </SuperadminLayout>
    );
};

export default EditarTipoContrato;
